import dashboardIcon from "../Assets/svg/Vector (1).svg";
import UsersIcon from "../Assets/svg/Users.svg";
import Products from "../Assets/svg/Cube.svg";
import Kits from "../Assets/svg/Group 11.svg";
import Business from "../Assets/svg/Vector.svg";
import UserIcon from "../Assets/svg/User.svg";
import Reports from "../Assets/svg/ChartBar.svg";
// import Resources from "../Assets/svg/File.svg";
import Bell from "../Assets/svg/Bell.svg";
import { permissions } from "./helperFunction";

const {
  all,
  products,
  users,
  business,
  distributors,
  // resource,
  notifications,
  dist_super_admin,
  kitManagement,
  clients,
} = permissions;
const distributorAllAccess = [
  dist_super_admin,
  users,
  business,
  distributors,
  notifications,
];

export const menus = [
  {
    permission: [all],
    title: "Dashboard",
    icon: <img src={dashboardIcon} alt="Dashboard Icon" />,
    link: "/",
    activeFor: ["/"],
  },
  {
    permission: [all, products],
    title: "Products",
    icon: <img src={Products} alt="Products Icon" />,
    link: "/products",
    activeFor: ["/products"],
  },
  {
    permission: [all, kitManagement],
    title: "Kit Management",
    icon: <img src={Kits} alt="Kit Management Icon" />,
    link: "/kit",
    activeFor: ["/kit", "/createkit", "/createemptykit"],
  },
  {
    permission: [all, users],
    title: "Team Management",
    icon: <img src={UsersIcon} alt="Team Management Icon" />,
    link: "/users",
    activeFor: ["/users", "/create-users", "/update-user"],
  },
  {
    permission: [all, business],
    title: "Business Profile",
    icon: <img src={Business} alt="Business Profile Icon" />,
    link: "/businessprofile",
    activeFor: ["/businessprofile", "/createlocation"],
  },
  {
    permission: [all, distributors],
    title: "Distributors",
    icon: <img src={UserIcon} alt="User Icon" />,
    link: "/distributors",
    activeFor: ["/distributors", "/distributorinfo"],
  },
  {
    permission: [all],
    title: "Reports",
    icon: <img src={Reports} alt="Reports Icon" />,
    link: "/reports",
    activeFor: [
      "/reports",
      "/reporteditor",
      "/creategroupreport",
      "/edit_report_group",
    ],
  },
  // {
  //   permission: [all, resource],
  //   title: "Resources",
  //   icon: <img src={Resources} alt="Resources Icon" />,
  //   link: "/resource",
  //   activeFor: ["/resource"],
  // },
  {
    permission: [all],
    title: "Notifications Centre",
    icon: <img src={Bell} alt="Notifications Centre Icon" />,
    link: "/messaging",
    activeFor: ["/messaging", "/editarticle", "/edit-notification"],
  },
  // {
  //   title: "Notifications",
  //   icon: <img src={Bell} />,
  //   link: "/notifications",
  // },
];

export const distributorMenus = [
  {
    permission: distributorAllAccess,

    title: "Dashboard",
    icon: <img src={dashboardIcon} alt="Dashboard Icon" />,
    link: "/distributor",
    activeFor: ["/distributor"],
  },
  {
    permission: [dist_super_admin, users],

    title: "Team Management",
    icon: <img src={UsersIcon} alt="Team Management Icon" />,
    link: "/distributor-user-management",
    activeFor: [
      "/distributor-user-management",
      "/distributor-invite-admin",
      "/distributor-create-user",
      "/distributor-update-distributor-user/:id",
    ],
  },
  {
    permission: [dist_super_admin, business],
    title: "Business Profile",
    icon: <img src={Business} alt="Business Profile Icon" />,
    link: "/distributor-business-profile",
    activeFor: [
      "/distributor-business-profile",
      "/distributor-create-location",
    ],
  },
  {
    permission: [dist_super_admin, clients],
    title: "Clients",
    icon: <img src={UserIcon} alt="Clients Icon" />,
    link: "/distributor-clients",
    activeFor: ["/distributor-clients"],
  },
  // {
  //   permission: distributorAllAccess,
  //   title: "QR Code",
  //   icon: <img src={UserIcon} alt="QR Code Icon" />,
  //   link: "/distributor/distributor-QR",
  //   activeFor: ["/distributor/distributor-QR"],
  // },
  // {
  //   permission: [dist_super_admin, notifications],

  //   title: "Notification",
  //   icon: <img src={Bell} alt="Notification Icon" />,
  //   link: "/distributor/notifilcation",
  //   activeFor: ["/distributor/notifilcation"],
  // },
];
